// Official Vittaniti wordmark — rendered as inline text so it scales
// crisply at every size and stays perfectly transparent on any background.
// Matches the supplied brand asset: heavy sans-serif "Vittaniti" with a
// red accent period.
//
// Props:
//   height   numeric pixel height of the rendered mark (defaults to 32)
//   tone     "dark" (black on light bg, default) | "light" (white on dark bg)
//   title    accessible label
//   className extra utility classes (e.g. "shrink-0")

export default function LogoWordmark({
    height = 32,
    tone = "dark",
    className = "",
    title = "Vittaniti",
}) {
    const color = tone === "light" ? "#FFFFFF" : "#0B0B0B";
    // Font-size produces an "x-height" roughly equal to the requested mark height
    // when using the heavy sans-serif Manrope/Inter stack already loaded site-wide.
    const fontSize = Math.round(height * 0.92);
    return (
        <span
            role="img"
            aria-label={title}
            className={`inline-flex items-baseline select-none ${className}`}
            style={{
                fontFamily:
                    '"Manrope", "Inter", "Helvetica Neue", Arial, sans-serif',
                fontWeight: 800,
                fontSize: `${fontSize}px`,
                lineHeight: 1,
                letterSpacing: "-0.02em",
                color,
            }}
            data-testid="logo-wordmark"
        >
            Vittaniti
            <span style={{ color: "#E53935", marginLeft: "0.02em" }}>.</span>
        </span>
    );
}
